import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { RestaurantLayout } from "@/components/tabdine/RestaurantLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Loyalty() {
  const [cfg, setCfg] = useState(null);
  const [balances, setBalances] = useState([]);

  const load = () => api.get("/restaurant/loyalty").then((r) => {
    setCfg(r.data.config || {
      stamps_required: 10, reward_description: "Free dessert on next visit",
      reward_value: 100, points_per_rupee: 1.0, is_active: true,
    });
    setBalances(r.data.balances || []);
  });
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.post("/restaurant/loyalty", cfg);
    toast.success("Loyalty saved");
    load();
  };

  if (!cfg) return <RestaurantLayout><div className="p-6">Loading…</div></RestaurantLayout>;

  return (
    <RestaurantLayout>
      <div className="p-4 lg:p-8 max-w-3xl">
        <h1 className="font-heading text-2xl font-bold text-brand-dark mb-4">Loyalty & Stamps</h1>
        <div className="bg-white rounded-xl border border-brand-dark/5 p-4 space-y-3">
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={cfg.is_active} onChange={(e) => setCfg({ ...cfg, is_active: e.target.checked })} data-testid="loyalty-toggle" /> Loyalty programme active
          </label>
          <div>
            <label className="text-xs text-brand-dark/60">Stamps required</label>
            <Input type="number" value={cfg.stamps_required} onChange={(e) => setCfg({ ...cfg, stamps_required: +e.target.value })} data-testid="stamps-required" />
          </div>
          <div>
            <label className="text-xs text-brand-dark/60">Reward description</label>
            <Input value={cfg.reward_description} onChange={(e) => setCfg({ ...cfg, reward_description: e.target.value })} data-testid="reward-desc" />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-brand-dark/60">Reward value (₹)</label>
              <Input type="number" value={cfg.reward_value} onChange={(e) => setCfg({ ...cfg, reward_value: +e.target.value })} />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">Points per ₹1</label>
              <Input type="number" step="0.1" value={cfg.points_per_rupee} onChange={(e) => setCfg({ ...cfg, points_per_rupee: +e.target.value })} />
            </div>
          </div>
          <Button onClick={save} className="bg-brand-orange text-white" data-testid="save-loyalty">Save</Button>
        </div>

        <div className="mt-6">
          <div className="font-heading font-semibold text-brand-dark mb-2">Top loyal customers</div>
          <div className="bg-white rounded-xl border border-brand-dark/5">
            {balances.length === 0 && <div className="text-sm text-brand-dark/60 p-4">No customers earned stamps yet.</div>}
            {balances.map((b) => (
              <div key={b.id} className="p-3 border-b border-brand-dark/5 last:border-0 flex justify-between text-sm">
                <span>Customer {b.customer_id.slice(0, 8)}</span>
                <span>{b.stamps_earned} stamps · {b.points_balance.toFixed(0)} pts</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </RestaurantLayout>
  );
}
